import { Injector } from "@angular/core";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";
import { XevprmMessageEntity } from "../../../Data/MedicinalProductData/XevprmMessageEntity";
import { TreeNodeMedicinalProductsAuthorisedProduct } from "../ListEntity/TreeNodeMedicinalProductsAuthorisedProduct";
import { TreeNodeMedicinalProductsDevelopmentProduct } from "../ListEntity/TreeNodeMedicinalProductsDevelopmentProduct";
import { TreeNodeMedicinalProductsApprovedSubstance } from "../ListEntity/TreeNodeMedicinalProductsApprovedSubstance";
import { TreeNodeMedicinalProductsDevelopmentSubstance } from "../ListEntity/TreeNodeMedicinalProductsDevelopmentSubstance";
import { TreeNodeMedicinalProductsATCcode } from "../ListEntity/TreeNodeMedicinalProductsATCcode";
import { TreeNodeMedicinalProductsAttachment } from "../ListEntity/TreeNodeMedicinalProductsAttachment";
import { TreeNodeMedicinalProductsSource } from "../ListEntity/TreeNodeMedicinalProductsSource";
import { TreeNodeMedicinalProductsMAH } from "../ListEntity/TreeNodeMedicinalProductsMAH";
import { TreeNodeMedicinalProductsSponsor } from "../ListEntity/TreeNodeMedicinalProductsSponsor";
import { TreeNodeMedicinalProductsROA } from "../ListEntity/TreeNodeMedicinalProductsROA";
import { TreeNodeMedicinalProductsPharmaceuticalForm } from "../ListEntity/TreeNodeMedicinalProductsPharmaceuticalForm";
import { TreeNodeMedicinalProductsMFL } from "../ListEntity/TreeNodeMedicinalProductsMFL";
import { TreeNodeMedicinalProductsXevprmMessage } from "../ListEntity/TreeNodeMedicinalProductsXevprmMessage";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";
import { SectionService } from "../../../../service/section-service/section-service";

export class XevprmMessageAutoUploadEntity extends OnDemandAutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any,useHist: boolean, disableAutoUpload:boolean,cloningNode:boolean) {
        super(injector, 
            labelTemplate, 
            XevprmMessageEntity, 
            AutoUploadEntityEnum.xevprmMessage, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            undefined, // this node is not part of CreateXEVPRMMessage for create and send products reports from medicinal products
            !cloningNode, 
            disableAutoUpload,
            cloningNode,
            {});
            this.labelNodeName = 'XEVPRM Message';
            this.useHist = useHist;
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      const labelTemplate = this.labelTemplate;
      let clonedNode: XevprmMessageAutoUploadEntity = new XevprmMessageAutoUploadEntity(this.ioc!, `${labelTemplate}`,newParent,this.datasource, this.useHist, this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }

    override postLoadEntity(model: any): void {
        const parentedNode:any = Art57NodeUtils.findFirstParentNodeOfType(this, TreeNodeMedicinalProductsXevprmMessage);
        if (parentedNode == undefined || parentedNode.parent !== undefined) {
            return;
        }

        const authorisedProductAutoUploadEntity = new TreeNodeMedicinalProductsAuthorisedProduct(this.ioc!, undefined, true);
        authorisedProductAutoUploadEntity.parent = this;
        authorisedProductAutoUploadEntity.loadEntityNode (model.authorisedProducts);
        this.children?.push(authorisedProductAutoUploadEntity);

        const developmentProductAutoUploadEntity = new TreeNodeMedicinalProductsDevelopmentProduct(this.ioc!, undefined, true);
        developmentProductAutoUploadEntity.parent = this;
        developmentProductAutoUploadEntity.loadEntityNode (model.developmentProducts);
        this.children?.push(developmentProductAutoUploadEntity);

        const approvedSubstanceAutoUploadEntity = new TreeNodeMedicinalProductsApprovedSubstance(this.ioc!, undefined, true);
        approvedSubstanceAutoUploadEntity.parent = this;
        approvedSubstanceAutoUploadEntity.loadEntityNode (model.approvedSubstances);
        this.children?.push(approvedSubstanceAutoUploadEntity);

        const developmentSubstanceAutoUploadEntity = new TreeNodeMedicinalProductsDevelopmentSubstance(this.ioc!, undefined, true);
        developmentSubstanceAutoUploadEntity.parent = this;
        developmentSubstanceAutoUploadEntity.loadEntityNode (model.developmentSubstances);
        this.children?.push(developmentSubstanceAutoUploadEntity);

        const sourceAutoUploadEntity = new TreeNodeMedicinalProductsSource(this.ioc!, undefined, true);
        sourceAutoUploadEntity.parent = this;
        sourceAutoUploadEntity.loadEntityNode (model.sources);
        this.children?.push(sourceAutoUploadEntity);

        const mahAutoUploadEntity = new TreeNodeMedicinalProductsMAH(this.ioc!, undefined, true);
        mahAutoUploadEntity.parent = this;
        mahAutoUploadEntity.loadEntityNode (model.mahs);
        this.children?.push(mahAutoUploadEntity);

        const sponsorAutoUploadEntity = new TreeNodeMedicinalProductsSponsor(this.ioc!, undefined, true);
        sponsorAutoUploadEntity.parent = this;
        sponsorAutoUploadEntity.loadEntityNode (model.sponsors);
        this.children?.push(sponsorAutoUploadEntity);

        const atcCodeAutoUploadEntity = new TreeNodeMedicinalProductsATCcode(this.ioc!, undefined, true);
        atcCodeAutoUploadEntity.parent = this;
        atcCodeAutoUploadEntity.loadEntityNode (model.atccodes);
        this.children?.push(atcCodeAutoUploadEntity);

        const roaAutoUploadEntity = new TreeNodeMedicinalProductsROA(this.ioc!, undefined, true);
        roaAutoUploadEntity.parent = this;
        roaAutoUploadEntity.loadEntityNode (model.roas);
        this.children?.push(roaAutoUploadEntity);

        const pharmaceuticalFormAutoUploadEntity = new TreeNodeMedicinalProductsPharmaceuticalForm(this.ioc!, undefined, true);
        pharmaceuticalFormAutoUploadEntity.parent = this;
        pharmaceuticalFormAutoUploadEntity.loadEntityNode (model.pharmforms);
        this.children?.push(pharmaceuticalFormAutoUploadEntity);

        const mflAutoUploadEntity = new TreeNodeMedicinalProductsMFL(this.ioc!, undefined, true);
        mflAutoUploadEntity.parent = this;
        mflAutoUploadEntity.loadEntityNode (model.mfls);
        this.children?.push(mflAutoUploadEntity);

        const attachmentAutoUploadEntity = new TreeNodeMedicinalProductsAttachment(this.ioc!, undefined, true);
        attachmentAutoUploadEntity.parent = this;
        attachmentAutoUploadEntity.loadEntityNode (model.attachments);
        this.children?.push(attachmentAutoUploadEntity);

        this.ioc!.get(SectionService).selectMedicinalProductsNode(this);
        
    }

    public getListItem(): any[] {
        return [this.data.model.localnumber, 
            this.data.model.messagenumber, 
            this.data.model.senderid,
             this.data.model.messagereceivedate, 
             this.data.model.ackdate];
             
    }

    override getOnDemandEntities() {
        if (this.parent instanceof OnDemandSimpleSearchListNode) {
            const onDemandEntities: any = super.getOnDemandEntities();
            if (Array.isArray(onDemandEntities ) || Object.keys(onDemandEntities ).length !== 0) {
                return {id: this.code, ...onDemandEntities};
            }
            return {};
        } else {
            return {...this.initialModel};
        }
    }
}